import React, {useRef, useState} from 'react';
import _ from 'lodash';
import {isMobile} from 'react-device-detect';
import {useSize} from 'ahooks';
import {Anchor, Alert} from '@enos/dpl';
import localeText, {getLocale} from '@locale';
import ListModal from '~/stores/models';
import {getLandingConfig} from '~/utils/tools';
import NotFound from '../../components/404';
import Header from '~/components/Header';
import MobileHeader from '~/components/MobileHeader/index';
import '../../assets/icons/portal/style.css';
import './index.less';

const {Link} = Anchor;
const Doc = ({history, match}) => {
  const {
    params: {locale, version}
  } = match;
  const pageRef = useRef(null);
  const pageSize = useSize(pageRef);
  const [menuOpen, setMenuOpen] = useState(false);

  const landingConfig = getLandingConfig(locale);

  const versionKeys = Object.keys(landingConfig).sort((p, n) => landingConfig[p].order - landingConfig[n].order);
  if (_.indexOf(versionKeys, version) === -1) {
    return <NotFound />;
  }

  const list = (landingConfig?.[version]?.content || []).map(item => {
    const l = new ListModal(this, item);
    l.updateDoc(item);
    return l;
  });

  const renderAnchor = data => data.map((i) => (
    <div className='item'><Link href={`#${i.category}`} title={i.category} /></div>
  ));

  const renderAlertDescription = data => {
    if (data.type === 'text') {
      return (
        <div>
          {data.content}
          <span className='learn-more'>
            <a href={data.url} target='blank' rel='noopener'>
              {localeText('COMMON.TXT_LEARN_MORE')}
            </a>
          </span>
        </div>
      );
    }
    if (data.type === 'link') {
      return (
        <ul>
          {data.content.map((d, index) => (
            <a className='item-sub-title' key={index} href={d.url} target='blank' rel='noopener'>
              <li>{d.text}</li>
            </a>
          ))}
        </ul>
      );
    }
  };

  const renderList = data => data.map((i, index) => (
    <div className='list' key={index}>
      <div className='category' id={i.category}>
        {i.image && <span className='image'><img src={require(`~/${i.image}`)} alt='' width='30' /></span>}
        {i.isVersionInfo ? <div className='card-title'>{i.category}</div> : i.category}
      </div>
      <div className='description'>
        {i.description}
        {i.url && <span className='learn-more'><a key={index} href={i.url} target='blank' rel='noopener'>{localeText('COMMON.TXT_LEARN_MORE')}</a></span>}
      </div>
      {i.messageTip ? (
        <Alert
          className='message-tip'
          type={i.messageTip.type}
          message={i.messageTip.message}
          description={renderAlertDescription(i.messageTip.description)}
          showIcon
        />
      ) : null}
      <div className='content'>{renderItem(i.item)}</div>
    </div>
  ));

  const renderItem = data => data.map((i, index) => (
    <div className='item' key={index}>
      <div className='item-name'>
        {i.image && <span className='image'><img src={require(`~/${i.image}`)} alt='' width='18' /></span>}{i.name}
      </div>
      <div className='item-description'>{i.description}</div>
      <div className='item-sub'>{renderSub(i.list)}</div>
    </div>
  ));

  const renderSub = data => data.map((i, index) => (
    <a className='item-sub-title' key={index} href={i.url} target='blank' rel='noopener'>
      <li>{i.name}</li>
    </a>
  ));

  const currentLangIsEn = getLocale() === 'en-US';
  return (
    <div className={`doc ${isMobile ? 'is-mobile' : 'is-web'}`} ref={pageRef}>
      {isMobile ? (
        <MobileHeader
          locale={locale}
          version={version}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          isTutorial={false}
          configData={landingConfig?.[version]?.header || []}
          versionKeys={versionKeys}
          history={history}
        />
      ) : (
        <Header
          locale={locale}
          version={version}
          pageSize={pageSize}
          isTutorial={false}
          configData={landingConfig?.[version]?.header || []}
          versionKeys={versionKeys}
          history={history}
          isLanding
        />
      )}
      <div className='banner'>
        <div className='content'>
          <div className='title'>
            <span>{localeText('COMMON.TXT_TITLE')}</span>
            <span className='version'>{`(${version.replace(/^\S/, (s) => s.toUpperCase())})`}</span>
          </div>
          <div className='description'>
            {localeText('COMMON.TXT_DESCRIPTION')}
            <div className='enos-link'>
              <span>{localeText('COMMON.TXT_ENOS_LINK_HINT1')}</span>
              <a className='link' href={currentLangIsEn ? 'https://developer.enos-iot.com/' : 'https://developer.enos-iot.com/zh_CN/'} target='blank'>
                {localeText('COMMON.TXT_ENOS_LINK_HINT2')}
              </a>
              <span>{localeText('COMMON.TXT_ENOS_LINK_HINT3')}</span>
            </div>
          </div>
        </div>
      </div>
      <Anchor offsetTop={isMobile ? 44 : 60} showInkInFixed={false}>
        <div className='doc-anchor'>
          <div className='anchor-list'>
            <div className='anchor-contain'>
              {renderAnchor(list)}
            </div>
          </div>
        </div>
      </Anchor>
      <div className='doc-list'>
        {renderList(list)}
      </div>
      <div className='copy-right'>{localeText('COMMON.TXT_COPY_RIGHT', new Date().getFullYear())}</div>
    </div>
  );
};

export default Doc;
